// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__tp8pq","content":"RecentSearches_content__3qeYH"};